import { render, staticRenderFns } from "./ParsingSentencePartsSpeech.vue?vue&type=template&id=29f486f6&lang=pug&"
import script from "./ParsingSentencePartsSpeech.vue?vue&type=script&lang=js&"
export * from "./ParsingSentencePartsSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports